import { makeURL } from '../../utils/Parents';

export default {
    state: {
        finalContent: [],
        contentList: {
            data: [],
        },
        topic: {},
        exercise: {},
        links: {},
    },

    actions: {
        LOAD_FINAL_CONTENT({ commit }, payload) {
            const URL = makeURL(payload.parents);
            const publicContent = payload.public ? '/public' : '';

            // Verifica se a aula é pública e caso seja, chama a rota pública
            return window.axios
                .get(`/api/app${URL}final/contents${publicContent}`, {
                    params: {
                        submodules: payload.submodules,
                        lessonPublic: !!payload.public,
                    },
                })
                .then(res => commit('SET_FINAL_CONTENT', res.data.data))
                .catch(err => console.error(err));
        },
        LOAD_FINAL_CONTENT_TOPIC({ commit }, payload) {
            const URL = makeURL(payload.parents);

            return window.axios
                .get(`/api/app${URL}final/topic/${payload.id}`, {
                    params: {
                        submodules: payload.submodules,
                    },
                })
                .then(res => commit('SET_FINAL_CONTENT_TOPIC', res.data))
                .catch(err => console.error(err));
        },
        LOAD_FINAL_CONTENT_EXERCISE({ commit }, payload) {
            const URL = makeURL(payload.parents);

            return window.axios
                .get(`/api/app${URL}final/exercise/${payload.id}`, {
                    params: {
                        submodules: payload.submodules,
                    },
                })
                .then(res => commit('SET_FINAL_CONTENT_EXERCISE', res.data))
                .catch(err => console.error(err));
        },
        LOAD_LIST_CONTENT({ commit }, payload) {
            const URL = makeURL(payload.parents);
            const publicContent = payload.public ? '/public' : '';

            // Verifica se a aula é pública e caso seja, chama a rota pública
            return window.axios
                .get(`/api/app${URL}contents${publicContent}`, {
                    params: {
                        per_page: payload.per_page,
                        page: payload.page,
                        submodules: payload.submodules,
                        lessonPublic: !!payload.public,
                    },
                })
                .then((res) => {
                    commit('SET_LIST_CONTENT', {
                        data: res.data,
                        pagination: payload.pagination,
                    });
                })
                .catch(err => console.error(err));
        },
        LOAD_LINKS({ commit }, payload) {
            const URL = makeURL(payload.parents);
            const publicContent = payload.public ? '/public' : '';

            // Se temos uma URL assinada para links, usamos ela diretamente
            if (payload.signedUrl) {
                return window.axios
                    .get(payload.signedUrl)
                    .then(res => commit('SET_LINKS', res.data.links))
                    .catch(err => console.error(err));
            }

            // Caso contrário, usamos a URL normal
            return window.axios
                .get(`/api/app${URL}links${publicContent}`, {
                    params: {
                        submodules: payload.submodules,
                        lessonPublic: !!payload.public,
                    },
                })
                .then(res => commit('SET_LINKS', res.data.links))
                .catch(err => console.error(err));
        },
    },

    mutations: {
        SET_LINKS(state, payload) {
            state.links = payload;
        },
        SET_FINAL_CONTENT(state, payload) {
            state.finalContent = payload;
        },
        SET_FINAL_CONTENT_TOPIC(state, payload) {
            state.topic = payload;
        },
        SET_FINAL_CONTENT_EXERCISE(state, payload) {
            state.exercise = payload;
        },
        SET_LIST_CONTENT(state, payload) {
            state.contentList = {
                meta: payload.data.meta,
                links: payload.data.links,
                data: payload.pagination
                    ? [...state.contentList.data, ...payload.data.data]
                    : [...payload.data.data],
            };
        },
        CHANGE_CONTENT(state, payload) {
            const data = state.contentList.data.map((item) => {
                if (item.id == payload.id) {
                    const completed = payload.progress === 100;
                    item = { ...item, ...payload, completed };
                }
                return item;
            });
            state.contentList = { ...state.contentList, data };
        },
    },

    getters: {
        LOADED_FINAL_CONTENT(state) {
            return state.finalContent;
        },
        LOADED_FINAL_TOPIC(state) {
            return state.topic;
        },
        LOADED_FINAL_EXERCISE(state) {
            return state.exercise;
        },
        LOADED_LIST_CONTENT(state) {
            return state.contentList;
        },
        LOADED_CONTENT_LINKS(state) {
            return state.links;
        },
        LOADED_VIDEO(state) {
            return state.video;
        },
    },
};
